module.exports = "/_next/static/images/truck5-7067ff1753d8bba64a09e9e2e804e15b.png.webp";